import React, { useState } from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import { Orders, OrdersHistory } from "routes";
import navigation from "routes/navigationConfig";
import Header from "components/Header";
import Navigator from "components/Navigator";
import useStyles from "./styles";

const MainLayout = ({ authed }) => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div className={classes.root}>
      <Header open={drawerOpen} />
      <nav>
        <Navigator navigation={navigation} open={drawerOpen} onClose={() => toggleDrawer} />
      </nav>
      <main className={classes.main}>
        <div className={classes.toolbar} />
        <Switch>
          <Route path={"/orders/history"} render={props => <OrdersHistory authed={authed} {...props} />} />
          <Route path={["/", "/orders"]} render={props => <Orders authed={authed} {...props} />} />
        </Switch>
      </main>
    </div>
  );
};

MainLayout.propTypes = {
  authed: PropTypes.bool.isRequired
};

export default MainLayout;
